(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["event-archive"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('event-roadmap')) {
    customElements.define('event-roadmap', class extends HTMLElement {
      connectedCallback() {
        this.desktopQuery = window.matchMedia('(min-width: 990px)');
        this.items = Array.from(this.querySelectorAll('.event-archive__item'));
        this.scheduleUpdate = () => {
          window.cancelAnimationFrame(this.updateFrame);
          this.updateFrame = window.requestAnimationFrame(() => this.updateOverlap());
        };
        this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
        this.items.forEach((item) => {
          const body = item.querySelector('.event-archive__body');
          if (body) this.resizeObserver.observe(body);
        });
        this.desktopQuery.addEventListener('change', this.scheduleUpdate);
        this.scheduleUpdate();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.desktopQuery?.removeEventListener('change', this.scheduleUpdate);
        window.cancelAnimationFrame(this.updateFrame);
      }

      updateOverlap() {
        const parsedLimit = Number.parseFloat(this.dataset.overlapLimit);
        const overlapLimit = Number.isFinite(parsedLimit) ? parsedLimit : 128;

        this.items.forEach((item, index) => {
          let overlap = 0;
          if (this.desktopQuery.matches && index > 0) {
            const body = item.querySelector('.event-archive__body');
            if (body) overlap = Math.min(body.getBoundingClientRect().height * 0.42, overlapLimit);
          }
          item.style.setProperty('--timeline-item-overlap', `${Math.floor(overlap)}px`);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            this.classList.add('products-loaded');
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
